import { ActionTree } from "vuex";
import { RootState, RootActions } from "@/store/interfaces/root";
import { ActionTypes } from "./action-types";
import { MutationTypes } from "./mutation-types";
import { Fetch } from "@/plugins/fetch";
import moment from "moment";

export const actions: ActionTree<RootState, RootState> & RootActions = {
  /**
    Update global loading state
    @var commit - start mutation handler
    @param payload - next state (boolean)
  */

  async [ActionTypes.UPDATE_LOADING_STATUS]({ commit }, payload) {
    commit(MutationTypes.SET_LOADING_STATUS, payload);
  },

  /**
    Fetch csrf-token for session
    @var commit - start mutation handler
  */

  async [ActionTypes.FETCH_CSRF_INFORMATION]({ commit }) {
    await Fetch.post("user/token")
      .then(res => {
        commit(MutationTypes.SET_CSRF_INFORMATION, {
          status: true,
          token: res.token,
          didInvalidate: false,
          receivedAt: moment().unix(),
          connectionError: false
        });
      })
      .catch(error => {
        commit(MutationTypes.SET_CSRF_INFORMATION, {
          status: false,
          token: "",
          didInvalidate: true,
          receivedAt: moment().unix(),
          connectionError: true
        });
        throw error;
      });
  },

  /**
    Update global banner state
    @var commit - start mutation handler
    @param payload 
      - next state {
        status: boolean,
        component: string
      }
  */

  async [ActionTypes.UPDATE_BANNER_STATUS]({ commit }, payload) {
    commit(MutationTypes.SET_BANNER_STATUS, payload);
  },

  /**
    Update global dialog state
    @var commit - start mutation handler
    @param payload
      - next state {
        status: boolean,
        component: string
      }
  */

  async [ActionTypes.UPDATE_DIALOG_STATUS]({ commit }, payload) {
    commit(MutationTypes.SET_DIALOG_STATUS, payload);
  },

  /**
    Update global notification state
    @var commit - start mutation handler
    @param payload
      - next state {
        status: boolean;
        component: string;
        position?: string;
        autoDismiss?: boolean;
      }
  */

  async [ActionTypes.UPDATE_NOTIFICATION_STATUS]({ commit }, payload) {
    commit(MutationTypes.SET_NOTIFICATION_STATUS, payload);
  },

  /**
    Update global alert state
    @var commit - start mutation handler
    @param payload
      - next state {
        status: boolean,
        component: string
      }
  */

  async [ActionTypes.UPDATE_ALERT_STATUS]({ commit }, payload) {
    commit(MutationTypes.SET_ALERT_STATUS, payload);
  }
};
